import Text from 'components/Text/Text';
import React, { useState, useMemo, useCallback } from 'react';
import { IItemForGetShortInfoWithStatus } from 'types';
import { useArchivedMultiSelect } from 'hooks/useArchivedMultiSelect';
import { Checkbox } from 'antd';
import SearchField from 'components/SearchField/SearchField';
import FormSelect from 'components/Select/FormSelect';
import style from './MultipleSelect.module.scss';

interface IMultipleSelect {
	data: IItemForGetShortInfoWithStatus[];
	setIDsRestaurant: (value: string[]) => void;
	IDsSelectedRestaurant: string[];
	inputName: string;
	inputLabel: string;
}

const MultipleSelect: React.FC<IMultipleSelect> = ({
	data,
	setIDsRestaurant,
	IDsSelectedRestaurant,
	inputName,
	inputLabel,
}) => {
	const [searchString, setSearchString] = useState<string>('');

	const { showArchived, toggleShowArchived, visibleItems, options } = useArchivedMultiSelect({
		items: data,
		entityType: 'restaurants',
		selectedIds: IDsSelectedRestaurant,
	});

	const filteredData = useMemo(() => {
		return searchString
			? options.filter((el) => el.name.toLowerCase().includes(searchString.toLowerCase()))
			: options;
	}, [searchString, options]);

	const handleSelectAllData = useCallback(() => {
		if (visibleItems.length && visibleItems.length === IDsSelectedRestaurant.length) {
			setIDsRestaurant([]);
		} else {
			setIDsRestaurant(visibleItems.map((el) => el.id));
		}
	}, [visibleItems, IDsSelectedRestaurant, setIDsRestaurant]);

	const renderSelectMenu = useCallback(
		(menu: React.ReactElement) => {
			return (
				<>
					<div className={style.selectMenuHeader}>
						<Checkbox
							className={style.checkBox}
							checked={!!(visibleItems.length && visibleItems.length === IDsSelectedRestaurant.length)}
							disabled={!visibleItems.length}
							onChange={handleSelectAllData}>
							<Text
								translationNameSpace="form"
								translationKey="selectAllRestaurantsLabel"
								asFragment={true}
							/>
						</Checkbox>
						<Checkbox className={style.checkBox} checked={showArchived} onChange={toggleShowArchived}>
							<Text translationNameSpace="modals" translationKey="showArchived" asFragment={true} />
						</Checkbox>
						<SearchField
							onChangeSelectSearchString={setSearchString}
							searchString={searchString}
							className={style.searchField}
						/>
					</div>
					{menu}
				</>
			);
		},
		[
			visibleItems,
			IDsSelectedRestaurant,
			handleSelectAllData,
			searchString,
			setSearchString,
			showArchived,
			toggleShowArchived,
		],
	);

	return (
		<FormSelect
			testId="MultipleSelect"
			name={inputName}
			label={inputLabel}
			options={filteredData}
			disabled={!data.length}
			onChange={setIDsRestaurant}
			mode="multiple"
			counterValue={IDsSelectedRestaurant.length}
			dropdownRender={renderSelectMenu}
		/>
	);
};

export default React.memo(MultipleSelect);
